window.PH = window.PH || {};

PH.ui = {
  renderAdvisor(container, advice) {
    if (!container) return;

    if (!advice) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }

    container.hidden = false;
    container.innerHTML = `
      <div class="ph-advisor-card">
        <div class="ph-advisor-card__icon">${advice.icon}</div>
        <div>
          <strong>${advice.title}</strong>
          <p>${advice.description}</p>
        </div>
      </div>
    `;
  },

  renderAssistant(container, filters, activeId) {
    if (!container) return;

    container.innerHTML = filters.map(filter => {
      const active = activeId === filter.id ? 'is-active' : '';

      return `
        <button
          type="button"
          class="ph-assistant-chip ${active}"
          data-ph-filter="${filter.id}"
        >
          ${filter.label}
        </button>
      `;
    }).join('');
  },

  renderSearchCard(item, mode = 'package') {
    const name = item.name || item.title || 'Aroma PH';
    const isPackageMode = mode === 'package';

    const image = item.image
      ? `<img src="${item.image}" alt="${name}" loading="lazy" width="400" height="400">`
      : `<span>PH</span>`;

    const badge = item.available
      ? `<span class="ph-badge ph-badge--success">🟢 Disponible</span>`
      : `<span class="ph-badge ph-badge--danger">🔴 Agotado</span>`;

    const meta = [
      item.inspiredBy ? `Inspirado en ${item.inspiredBy}` : '',
      item.family || '',
      item.gender || ''
    ].filter(Boolean);

    const reason = item.recommendationReason
      ? `<span class="ph-search-card__reason">${item.recommendationReason}</span>`
      : '';

    const cta = isPackageMode
      ? '<span class="ph-search-card__cta" aria-hidden="true">+</span>'
      : `
        <span class="ph-search-card__cta ph-search-card__cta--view" aria-hidden="true">
          <span class="ph-search-card__cta-full">Ver perfume</span>
          <span class="ph-search-card__cta-short">Ver</span>
          <span>→</span>
        </span>
      `;

    return `
      <button
        type="button"
        class="ph-search-card ph-card"
        data-ph-add-fragrance="${item.id}"
        aria-label="${isPackageMode ? 'Agregar' : 'Ver'} ${name}"
        ${!item.available ? 'disabled' : ''}
      >
        <span class="ph-search-card__image">
          ${image}
        </span>

        <span class="ph-search-card__body">
          <strong>${name}</strong>
          ${reason}

          ${meta.length ? `
            <small class="ph-search-card__meta">
              ${meta.join(' · ')}
            </small>
          ` : ''}

          ${badge}
        </span>

        ${cta}
      </button>
    `;
  },

  renderSelectedItem(item) {
    return `
      <div class="ph-selected-item ph-card">
        <span>${item.name || item.title}</span>
        <button type="button" data-ph-remove-fragrance="${item.id}">
          Quitar
        </button>
      </div>
    `;
  },

  renderSearchResults(container, results) {
    if (!container) return;

    const modeRoot = container.closest(
      '[data-ph-mode], [data-ph-home-search], .ph-home-search'
    );

    const mode = modeRoot?.dataset.phMode ||
      (modeRoot?.matches('[data-ph-home-search], .ph-home-search')
        ? 'home'
        : 'package');

    container.innerHTML = results
      .map(item => this.renderSearchCard(item, mode))
      .join('');
  },

  renderSelectedList(container, selected) {
    if (!container) return;

    container.innerHTML = selected
      .map(item => this.renderSelectedItem(item))
      .join('');
  },

  renderCounter(counter, selected, limit) {
    if (!counter) return;
    counter.textContent = `${selected.length}/${limit}`;
  },

  renderProgress(progressBar, selected, limit) {
    if (!progressBar) return;

    const percent = limit > 0
      ? Math.min((selected.length / limit) * 100, 100)
      : 0;

    progressBar.style.width = `${percent}%`;
  },

  renderCompleteMessage(element, selected, limit) {
    if (!element) return;
    element.hidden = selected.length !== limit;
  }
};
